import { render, staticRenderFns } from "./ecpa-info.vue?vue&type=template&id=4b71ebef&scoped=true"
import script from "./ecpa-info.ts?vue&type=script&lang=ts&external"
export * from "./ecpa-info.ts?vue&type=script&lang=ts&external"
import style0 from "./ecpa-info.scss?vue&type=style&index=0&id=4b71ebef&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71ebef",
  null
  
)

export default component.exports